export const firebaseConfig = {
    apiKey: "AIzaSyDHdKLVW504A5N3wT4HB2wFX2oasnMSmLk",
    authDomain: "biankaweb-5f19d.firebaseapp.com",
    databaseURL: "https://biankaweb-5f19d.firebaseio.com",
    storageBucket: "biankaweb-5f19d.appspot.com",
    messagingSenderId: "807923983817"
};


// WEBPACK FOOTER //
// ./src/firebase/config.js